import React, { useEffect } from 'react'
import {
  notification,
  Button,
  //  Modal
} from 'antd'
import { IS_ELECTRON } from '../../utils/config'

const UpdateButton = ({ notificationKey }) => {
  return (
    <>
      <Button
        type="ghost"
        style={{ marginRight: '8px' }}
        onClick={() => {
          notification.close(notificationKey)
        }}
      >
        No, thanks
      </Button>{' '}
      <Button
        type="primary"
        onClick={() => {
          window.ipcRenderer.send('updateNow')
        }}
      >
        Update now
      </Button>
    </>
  )
}

const notificationDisktop = (version) => {
  const key = `open${Date.now()}`
  notification.info({
    message: `New version v${version} available.  Would you like to update now?`,
    // description: "Update Now ?",
    placement: 'bottomRight',
    bottom: 10,
    duration: 30,
    key,
    btn: <UpdateButton notificationKey={key} />,
  })
}

// const modalVersionDistop = (version) => {
//     Modal.confirm({
//     title:   (<div className="flexible flex-align-center"><span className="font-exbold">New Version v{version}</span></div>),
//         content: 'Check The New Version, Already Downloaded, Install Now ?',
//         cancelText: 'Cancel',
//         okText:'Update Now',
//         onCancel() {
//             notificationDisktop(version);
//         },
//         onOk() {
//             window.ipcRenderer.send("updateNow");
//         }
//     });
// }

function autoUpdate() {
  window.ipcRenderer.on('update_message', (e, params) => {
    console.log('[ELECTRON_UPDATE_MESSAGE]: ', params)
  })
  // 下载完成 是否立即更新
  window.ipcRenderer.on('isUpdateNow', (e, info) => {
    // info = {
    //     downloadedFile: "C:\Users\Admin\AppData\Local\cocofax-app-updater\pending\CocoFax_1.0.2.exe"
    //     files: [{url: "CocoFax_1.0.2.exe", sha512: "xxx", size: 49676073}]
    //     path: "CocoFax_1.0.2.exe"
    //     releaseDate: "2020-05-26T10:21:06.537Z"
    //     sha512: "xxx"
    //     version: "1.0.2"
    // }
    const { version } = info

    // 是否提示用户  (代码会自动替换，下次打开App就是新版本，提示用户只是做了重启App)
    // const isShowVersionModal = true;
    // if(isShowVersionModal) {
    // modalVersionDistop(version);
    notificationDisktop(version)
    // }else {
    //     window.ipcRenderer.send("updateNow");
    // }
  })
  window.ipcRenderer.send('checkForUpdate')
}

export function ElectronUpdater() {
  useEffect(() => {
    // 开始检查更新
    if (IS_ELECTRON) {
      console.log('[ELECTRON_UPDATE_MESSAGE]: CHECK START')
      autoUpdate()
    }
    // dev test
    // modalVersionDistop("1.0.2");
    // notificationDisktop("1.0.3");
  }, [])
  return null
}
